<app-ag-grid-table
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [autopopulateSelect]="autopopulateSelect"
  [columnSelection]="columnSelection"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
>
</app-ag-grid-table>
